import { TitleSkeletonComponent } from './title-skeleton.component';

export default angular
  .module('sfMobile.components.title-skeleton', [
    'sfMobile.components.text-skeleton',
  ])
  .component('sfTitleSkeleton', TitleSkeletonComponent).name;
